export default {
	getAddress(data) {
		return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${ data }&key=AIzaSyB66NqIz7OonJc0SrmNebMBoXtExaAWOKo`).then(resp => resp.json()).catch(error => error);
	},
};
